import React, { useState } from "react";
import CreatePricelist from "../../components/pricing/CreatePricelist";
import Typography from "@mui/material/Typography";
import InnerPage from "../../components/InnerPage";

export default function CreatePricelistScreen({ user }) {
  const [step, setStep] = useState(1);
  return (
    <InnerPage title={`Create Price List - Step ${step}`}>
      <CreatePricelist user={user} setStep={setStep} />
    </InnerPage>
  );
}
